import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
import parameters from '../../parameters';

/** Base API path of a dossier; callers append the rest of the route. */
const buildSubjectApiPath = (facilityId: number, subject: SubjectAddress): string => {
	return `${parameters.api.host}/api/facilities/${facilityId}/subjects/${subject.subjectId}`;
};

export default buildSubjectApiPath;
